/**
 * Форматирует число с плавающей запятой через Intl.NumberFormat.
 * @param {number} num - Число для форматирования.
 * @param {number} [fractionDigits] - Максимальное количество знаков после запятой.
 * @param {string} [locale] - Локаль для форматирования.
 * @returns {string} Отформатированное число.
 */
const formatFloatNum = (num, fractionDigits = 1, locale = 'en-US') => {
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: fractionDigits,
  }).format(num);
};

export default formatFloatNum;
